import { FaUtensils, FaChalkboardTeacher, FaMoneyCheckAlt, FaCalendarDay, FaUsers, FaArrowUp } from "react-icons/fa";
import { images } from '../constants'; 


const careerIntro = {
    sub: "Join Our Team",
    heading: "Become a Part of Our Restaurant Family",
    description: "Join our restaurant family and be a part of a dynamic team dedicated to delivering exceptional dining experiences. We are looking for passionate individuals who are enthusiastic about food, service, and hospitality. Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem enim nobis ea quo sint vero laboriosam ex repellendus.",
    points: [
        "Assist in Culinary Preparation",
        "Provide Outstanding Guest Service",
        "Contribute to Menu Development",
        "Ensure a Positive Dining Experience",
        "Collaborate in a Team-Oriented Environment",
    ],
};

const benefits = [
    {
        id: 1,
        icon: <FaUtensils />,
        title: "Culinary Expertise",
        description: "Advance your culinary skills with hands-on experience and training from top chefs in a dynamic kitchen environment.",
    },
    {
        id: 2,
        icon: <FaChalkboardTeacher />,
        title: "Professional Development",
        description: "Access a range of development programs to enhance your knowledge of food preparation, menu planning, and customer service.",
    },
    {
        id: 3,
        icon: <FaMoneyCheckAlt />,
        title: "Competitive Compensation",
        description: "Enjoy attractive salary packages and bonuses that reflect your dedication and skill in the culinary arts.",
    },
    {
        id: 4,
        icon: <FaCalendarDay />,
        title: "Flexible Scheduling",
        description: "Benefit from flexible work hours designed to fit your lifestyle while maintaining a work-life balance in a fast-paced environment.",
    },
    {
        id: 5,
        icon: <FaUsers />,
        title: "Collaborative Team",
        description: "Work in a collaborative environment where teamwork is encouraged, and every member contributes to creating exceptional dining experiences.",
    },
    {
        id: 6,
        icon: <FaArrowUp />,
        title: "Career Advancement",
        description: "Take advantage of career advancement opportunities within our restaurant, from kitchen roles to management positions.",
    },
];

const positions = [
    {
        id: 1,
        image: images.position1,
        title: 'Head Chef',
        details: {
            location: 'Restaurant Name, City',
            timing: 'Full Time',
            hours: 'Shifts, 24/7 Coverage',
            experience: 'Minimum 2 Years in Culinary Arts',
            position: 'Multiple Positions Available',
            days: 'Rotational Shifts, Including Weekends',
            salary: '$60K - $75K',
            deadline: 'Apply Now - Open Until Filled',
            phoneNumber: '123-456-7890',
        },
        overviews: [
            'We are seeking an experienced Head Chef to lead our kitchen team. As a Head Chef, you will oversee all kitchen operations, create innovative menus, and ensure the highest standards of food quality and presentation. If you have a passion for culinary excellence and leadership, we encourage you to apply for this position.',
        ],
        responsibilities: [
            'Developing and executing creative menus.',
            'Managing kitchen staff and overseeing food preparation.',
            'Ensuring high standards of hygiene and food safety.',
            'Ordering and managing kitchen inventory.',
            'Training and mentoring junior chefs.',
        ],
        qualifications: [
            'Degree in Culinary Arts or related field.',
            'Proven experience as a Head Chef or similar role.',
            'Strong leadership and team management skills.',
            'Excellent knowledge of culinary techniques and food safety standards.',
            'Creativity and passion for food.',
        ],
    },
    {
        id: 2,
        image: images.position2,
        title: 'Sous Chef',
        details: {
            location: 'Restaurant Name, City',
            timing: 'Full Time',
            hours: 'Shifts, 24/7 Coverage',
            experience: 'Minimum 2 Years in Culinary Arts',
            position: 'Multiple Positions Available',
            days: 'Rotational Shifts, Including Weekends',
            salary: '$50K - $65K',
            deadline: 'Apply Now - Open Until Filled',
            phoneNumber: '123-456-7890',
        },
        overviews: [
            'We are looking for a talented and driven Sous Chef to support our Head Chef in daily kitchen operations. You will help supervise food preparation, maintain kitchen standards, and ensure consistent quality and presentation of dishes. This role is ideal for a passionate individual with leadership skills and a flair for fine cuisine.',
        ],
        responsibilities: [
            'Assisting the Head Chef in menu planning and execution.',
            'Supervising kitchen staff and ensuring smooth operations.',
            'Maintaining hygiene and safety standards.',
            'Monitoring food inventory and kitchen supplies.',
            'Training and mentoring kitchen team members.',
        ],
        qualifications: [
            'Degree or diploma in Culinary Arts.',
            'Experience as a Sous Chef or in a similar leadership role.',
            'Strong organizational and multitasking abilities.',
            'Knowledge of food safety and hygiene regulations.',
            'Excellent communication and teamwork skills.',
        ],
    },
    {
        id: 3,
        image: images.position3,
        title: 'Pastry Chef',
        details: {
            location: 'Restaurant Name, City',
            timing: 'Full Time',
            hours: 'Shifts, 24/7 Coverage',
            experience: 'Minimum 2 Years in Baking & Pastry',
            position: 'Multiple Positions Available',
            days: 'Rotational Shifts, Including Weekends',
            salary: '$55K - $70K',
            deadline: 'Apply Now - Open Until Filled',
            phoneNumber: '123-456-7890',
        },
        overviews: [
            'We are hiring a skilled Pastry Chef to craft exceptional desserts and baked goods. The ideal candidate will be creative, detail-oriented, and passionate about delivering visually stunning and delicious pastries. Join our culinary team and bring sweetness to every plate.',
        ],
        responsibilities: [
            'Designing and preparing a wide variety of desserts, pastries, and baked goods.',
            'Monitoring ingredient stock and placing orders as needed.',
            'Maintaining a clean and organized pastry station.',
            'Ensuring all items meet quality and presentation standards.',
            'Collaborating with kitchen staff on seasonal and special event menus.',
        ],
        qualifications: [
            'Certification or degree in Baking and Pastry Arts.',
            'Previous experience in a professional pastry kitchen.',
            'Creative flair and attention to detail.',
            'Knowledge of baking techniques and food safety standards.',
            'Ability to manage time effectively and meet deadlines.',
        ],
    },
    {
        id: 4,
        image: images.position4,
        title: 'Line Cook',
        details: {
            location: 'Restaurant Name, City',
            timing: 'Full Time',
            hours: 'Shifts, 24/7 Coverage',
            experience: 'Minimum 1 Year in Professional Kitchen',
            position: 'Multiple Positions Available',
            days: 'Rotational Shifts, Including Weekends',
            salary: '$40K - $55K',
            deadline: 'Apply Now - Open Until Filled',
            phoneNumber: '123-456-7890',
        },
        overviews: [
            'We are looking for a dedicated Line Cook to join our kitchen team. As a Line Cook, you will prepare meals according to our restaurant’s standards and ensure that food is served hot and on time. If you are efficient, reliable, and passionate about cooking, we’d love to have you on board.',
        ],
        responsibilities: [
            'Preparing ingredients and cooking menu items in cooperation with the kitchen team.',
            'Ensuring proper food handling, storage, and sanitation practices.',
            'Setting up and stocking stations with all necessary supplies.',
            'Following recipes, portion controls, and presentation specifications.',
            'Maintaining cleanliness and organization of the kitchen area.',
        ],
        qualifications: [
            'High school diploma or equivalent.',
            'Previous experience as a Line Cook or in a similar role.',
            'Ability to work in a fast-paced environment.',
            'Basic knowledge of kitchen equipment and safety procedures.',
            'Teamwork, communication, and time management skills.',
        ],
    },
    {
        id: 5,
        image: images.position5,
        title: 'Restaurant Manager',
        details: {
            location: 'Restaurant Name, City',
            timing: 'Full Time',
            hours: 'Shifts, 24/7 Coverage',
            experience: 'Minimum 3 Years in Restaurant Management',
            position: '1 Position Available',
            days: 'Rotational Shifts, Including Weekends',
            salary: '$70K - $85K',
            deadline: 'Apply Now - Open Until Filled',
            phoneNumber: '123-456-7890',
        },
        overviews: [
            'We are looking for a motivated and experienced Restaurant Manager to oversee daily operations, ensure excellent customer service, and lead a high-performing team. If you have strong leadership skills and a passion for hospitality, this is a great opportunity to grow with us.',
        ],
        responsibilities: [
            'Managing day-to-day restaurant operations and staff schedules.',
            'Ensuring customer satisfaction through exceptional service.',
            'Overseeing inventory, ordering supplies, and managing budgets.',
            'Enforcing health and safety regulations.',
            'Training, mentoring, and evaluating team members.',
        ],
        qualifications: [
            'Degree or diploma in Hospitality Management is a plus.',
            'Proven experience as a Restaurant Manager or similar role.',
            'Strong leadership and interpersonal skills.',
            'Knowledge of POS systems and restaurant management software.',
            'Ability to work flexible hours, including weekends and holidays.',
        ],
    },
    {
        id: 6,
        image: images.position6,
        title: 'Catering Coordinator',
        details: {
            location: 'Restaurant Name, City',
            timing: 'Full Time',
            hours: 'Shifts, 24/7 Coverage',
            experience: 'Minimum 2 Years in Event or Catering Management',
            position: '1 Position Available',
            days: 'Rotational Shifts, Including Weekends',
            salary: '$50K - $65K',
            deadline: 'Apply Now - Open Until Filled',
            phoneNumber: '123-456-7890',
        },
        overviews: [
            'We are seeking a highly organized Catering Coordinator to manage and oversee all aspects of catering operations. From planning events to coordinating logistics, this role requires attention to detail and excellent communication skills.',
        ],
        responsibilities: [
            'Planning and coordinating catering services for events and functions.',
            'Working closely with clients to understand event requirements.',
            'Managing event logistics including food preparation and delivery schedules.',
            'Ensuring all catering orders are executed on time and meet quality standards.',
            'Collaborating with kitchen and service teams to ensure seamless execution.',
        ],
        qualifications: [
            'Bachelor’s degree in Hospitality or related field preferred.',
            'Experience in catering or event coordination.',
            'Strong organizational and multitasking skills.',
            'Excellent verbal and written communication abilities.',
            'Proficiency in scheduling, budgeting, and event planning tools.',
        ],
    }

];

export { positions, benefits, careerIntro };